import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";
import { Hero } from "@/components/home/Hero";
import { ServicesGrid } from "@/components/home/ServicesGrid";
import { Why } from "@/components/home/Why";
import { MapPanel } from "@/components/home/MapPanel";
import { Marquee } from "@/components/Marquee";
import { SectionHead } from "@/components/Section";
import { Eyebrow, MaskLines, Reveal } from "@/components/Motion";
import { ShortEnquiryForm } from "@/components/forms/ShortEnquiryForm";

const Wrap = ({ children, className = "", ...rest }) => (
  <section className={`py-24 lg:py-32 ${className}`} {...rest}>
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12">{children}</div>
  </section>
);

export default function Home() {
  const { t, lp } = useLang();
  const h = t.home;
  useSeo("home");
  return (
    <>
      <Hero />
      <Marquee items={h.capabilities} />
      <Wrap className="bg-[#F7F9FB]" data-testid="services-overview">
        <SectionHead eyebrow={h.servicesEyebrow} title={h.servicesTitle} intro={h.servicesIntro} />
        <ServicesGrid />
      </Wrap>
      <Why />
      <Wrap className="bg-white" data-testid="locations-section">
        <SectionHead eyebrow={h.locEyebrow} title={h.locTitle} intro={h.locIntro} />
        <MapPanel />
      </Wrap>
      <section className="relative overflow-hidden bg-[#1E3A5F] py-24 lg:py-32" data-testid="cta-section">
        <img src="/img/dusk.jpg" alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-[#1E3A5F]/70" aria-hidden="true" />
        <div className="relative mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
          <div className="lg:col-span-5">
            <Eyebrow light>{h.ctaEyebrow}</Eyebrow>
            <h2 className="mt-6 font-serif text-3xl leading-tight text-white sm:text-4xl lg:text-[2.9rem]"><MaskLines lines={[h.ctaTitle]} onView /></h2>
            <Reveal><p className="mt-6 text-[#C9D4E1]">{h.ctaNote}</p>
              <Link to={lp("/quote")} className="mt-6 inline-block text-sm font-semibold text-white underline decoration-[#C59B27] underline-offset-[6px]" data-testid="cta-full-form-link">{h.fullForm}</Link>
            </Reveal>
          </div>
          <Reveal className="lg:col-span-7" delay={0.1}>
            <ShortEnquiryForm dark testId="home-enquiry" />
          </Reveal>
        </div>
      </section>
    </>
  );
}
